import { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { Facebook, Phone, ShieldCheck } from "lucide-react";
import { useLocation } from "react-router-dom";
import { qualityForPath } from "../data/businessQuality";

export default function BusinessQualityLayer() {
  const { pathname } = useLocation();
  const item = useMemo(() => qualityForPath(pathname), [pathname]);
  const tagalog = window.localStorage.getItem("mysitecare-language") === "tl";
  const [mount, setMount] = useState(null);
  const [contacts, setContacts] = useState({ phone: null, facebook: null });

  useEffect(() => {
    if (!item) return undefined;
    const footers = document.querySelectorAll("footer");
    const footer = footers[footers.length - 1];
    if (!footer?.parentNode) return undefined;

    const node = document.createElement("div");
    node.dataset.mscQualityDisclosure = item.path;
    footer.parentNode.insertBefore(node, footer);
    setMount(node);

    const phone = document.querySelector('a[href^="tel:"]');
    const facebook = [...document.querySelectorAll('a[href*="facebook.com"]')]
      .find(link => !link.closest("[data-msc-quality-disclosure]"));
    setContacts({
      phone: phone ? { href: phone.href, label: phone.textContent.trim() || "Call" } : null,
      facebook: facebook ? { href: facebook.href, label: "Facebook" } : null,
    });

    return () => {
      node.remove();
      setMount(null);
      setContacts({ phone: null, facebook: null });
    };
  }, [pathname, item]);

  if (!item || !mount) return null;

  return createPortal(
    <>
      <aside className="msc-quality" data-msc-quality-disclosure aria-label="Research and accuracy information">
        <div className="msc-quality__inner">
          <ShieldCheck aria-hidden="true" size={22} />
          <div>
            <strong>{tagalog ? "Konseptong suportado ng research" : "Research-backed concept"}</strong>
            <p>
              {tagalog
                ? "Sinuri ang mga detalye at larawan ng negosyo laban sa ibinigay na research noong Agosto 20, 2026. Maaaring bahagyang pinaikli ang mga pampublikong review; ipinapakita lamang ang rating kapag nakatala ito sa pinagmulan."
                : "Business details and media were checked against the supplied research on August 20, 2026. Public-review text may be lightly paraphrased for length; ratings are shown only when the source recorded them."}
            </p>
          </div>
        </div>
      </aside>

      {(contacts.phone || contacts.facebook) && (
        <nav className="msc-contact-dock notranslate" translate="no" aria-label={`Verified contact options for ${item.name}`}>
          <span className="msc-contact-dock__name">{tagalog ? `Makipag-ugnayan sa ${item.name}` : `Contact ${item.name}`}</span>
          {contacts.phone && <a href={contacts.phone.href}><Phone aria-hidden="true" size={15} /> {tagalog ? "Tumawag" : "Call"}</a>}
          {contacts.facebook && <a href={contacts.facebook.href} target="_blank" rel="noopener noreferrer"><Facebook aria-hidden="true" size={15} /> {tagalog ? "Mag-message" : "Message"}</a>}
        </nav>
      )}
    </>,
    mount,
  );
}
